// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatawftm } from "../../../icons/mono/build/icon-statawftm.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatawftmIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatawftm.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatawftmIcon.displayName = 'StatawftmIcon';
}

export default StatawftmIcon;